import { Module, Version } from "types/generated";
import { AccessResult } from "utils/access";
import PermissionGateDropdownItem from "components/PermissionGate/DropdownMenuItem";

import { showDeleteConfirmation } from "./Modal";

type DeleteVersionButtonProps = {
  id: Version["id"];
  moduleId: Module["id"];
  number: Version["number"];
  onClickCb?: () => void;
  canManageModule: AccessResult;
};

const DeleteVersionButton = (props: DeleteVersionButtonProps) => {
  const { moduleId, id, number, onClickCb, canManageModule } = props;

  const handleShowModal = () => {
    showDeleteConfirmation({
      id,
      moduleId,
      number,
    });

    onClickCb?.();
  };

  return (
    <PermissionGateDropdownItem access={canManageModule} onAction={handleShowModal} danger>
      Delete
    </PermissionGateDropdownItem>
  );
};

export default DeleteVersionButton;
